import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';

import maqRsu from '../assets/images/maq-rsu.jpeg';
import entradaUsina from '../assets/images/entrada-usina.jpeg';

// Container for the whole section
const Section = styled.section.attrs({ id: 'solutions' })`
  padding: 4rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.grayDark};
`;

// Title of the section
const Title = styled.h2`
  text-align: center;
  font-size: 2rem;
  margin-bottom: 3rem;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.greenPrimary};
`;

// Cards container
const CardsContainer = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
`;

// Individual card
const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.grayLight};
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  flex: 1 1 300px;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-8px);
  }
`;

// Image style
const CardImage = styled.img`
  width: 100%;
  height: 360px;
  object-fit: cover;
  object-position: center;
  border-radius: 6px;
  margin-bottom: 1rem;
  user-select: none;
`;

// Card title
const CardTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.colors.blueLight};
  font-family: ${({ theme }) => theme.fonts.primary};
`;

// Card summary
const CardSummary = styled.p`
  font-size: 1rem;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.colors.grayDark};
  font-family: ${({ theme }) => theme.fonts.primary};
`;

// Differentials list
const DifferentialsList = styled.ul`
  list-style: disc inside;
  text-align: left;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.colors.grayDark};
  font-family: ${({ theme }) => theme.fonts.primary};
`;

// Button style
const CardButton = styled(Link)`
  background-color: ${({ theme }) => theme.colors.greenPrimary};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  padding: 0.5rem 1.5rem;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-decoration: none;
  display: inline-block;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blueLight};
  }
`;

const Solutions = () => {
  const { translations } = useLanguage();
  const cards = translations.solutions.cards;

  // Map card titles to images and routes
  const cardConfig = {
    'MAQ-RSU': {
      image: maqRsu,
      route: '/maq-rsu'
    },
    'Usina Cidade Limpa': {
      image: entradaUsina,
      route: '/usina-cidade-limpa'
    }
  };

  return (
    <Section>
      <Title>{translations.solutions.title}</Title>
      <CardsContainer>
        {cards.map((card) => (
          <Card key={card.title}>
            <CardImage 
              src={cardConfig[card.title]?.image || maqRsu} 
              alt={card.title} 
            />
            <CardTitle>{card.title}</CardTitle>
            <CardSummary>{card.summary}</CardSummary>
            <DifferentialsList>
              {card.differentials.map((diff, index) => (
                <li key={index}>{diff}</li>
              ))}
            </DifferentialsList>
            <CardButton to={cardConfig[card.title]?.route || '/'}>
              {card.button}
            </CardButton>
          </Card>
        ))}
      </CardsContainer>
    </Section>
  );
};

export default Solutions;
